const fn = {
  init: () => {
    document.querySelectorAll('.element-googlemaps').forEach((el) => fn.setupMapEmbed(el))
  },

  setupMapEmbed: (container) => {
    const mapHolder = container.querySelector('.google-map')

    if (!mapHolder) {
      return
    }

    const google = window.google
    const data = JSON.parse(mapHolder.dataset.json)
    const center = new google.maps.LatLng(data.lat, data.lng)

    const mapOptions = {
      center,
      zoom: 14,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      scrollwheel: false,
      styles: [
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
    }

    const map = new google.maps.Map(mapHolder, mapOptions)

    google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
      const marker = new google.maps.Marker({
        map: map,
        title: data.title,
        animation: google.maps.Animation.DROP,
        position: new google.maps.LatLng(data.lat, data.lng),
      })

      google.maps.event.addListener(marker, 'click', () => {
        window.open(data.mapLink)
      })
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
